// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRubric_root__3CjTZ","link":"ArticleRubric_link__1eWl6"};